/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Coverage_Item3Inputs */

const ja_playdata_about_coverage_item3 = /** @type {(inputs: Playdata_About_Coverage_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認知度の高いコミュニティ大会`)
};

const en_playdata_about_coverage_item3 = /** @type {(inputs: Playdata_About_Coverage_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Well-known community-organized tournaments`)
};

/**
* | output |
* | --- |
* | "Well-known community-organized tournaments" |
*
* @param {Playdata_About_Coverage_Item3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_coverage_item3 = /** @type {((inputs?: Playdata_About_Coverage_Item3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Coverage_Item3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_coverage_item3(inputs)
	return en_playdata_about_coverage_item3(inputs)
});